import React from "react";
import { Modal, Button } from "react-bootstrap";

import { v4 as uuid } from "uuid";
import axios from "axios";

export default function Remove(props) {
  const {
    onHide,
    show,
    id,
    skip,
    take,
    sortField,
    orderBy,
    onMerchants,
  } = props;

  const onDeleteMerchant = (e) => {
    e.preventDefault();
    axios
      .delete(`${process.env.REACT_APP_API_URL}partner/merchant`, {
        headers: {
          "x-requestid": uuid(),
        },
        data: {
          id: [id],
        },
      })
      .then((res) => {
        onMerchants(skip, take, sortField, orderBy);
        onHide(false);
      });
  };

  return (
    <Modal show={show} onHide={onHide} aria-labelledby="delete" centered>
      <form onSubmit={onDeleteMerchant}>
        <Modal.Header closeButton>
          <Modal.Title id="delete">Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">Are you sure to delete?</div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" type="submit">
            Delete
          </Button>
          <Button variant="light" onClick={() => onHide(false)}>
            Close
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
